import { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu as MenuIcon, X, Phone } from "lucide-react";
import { CONTACT } from "@/data/site";

const links = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/menu", label: "Menu", testid: "nav-link-menu" },
  { to: "/events", label: "Events", testid: "nav-link-events" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-tnt-bg/95 backdrop-blur-xl border-b border-tnt-border shadow-sm"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-11 sm:h-12">
          <Link
            to="/"
            data-testid="nav-brand"
            className="flex items-baseline gap-2 group"
          >
            <span className="font-display text-xl sm:text-2xl tracking-wider text-tnt-ink group-hover:gold-text transition-colors">
              TAPS &amp; TUNES
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                className={({ isActive }) =>
                  `font-display text-sm tracking-[0.18em] uppercase transition-colors ${
                    isActive
                      ? "text-tnt-gold"
                      : "text-tnt-ink/85 hover:text-tnt-gold"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={`tel:${CONTACT.phoneTel}`}
              data-testid="nav-call-cta"
              className="btn-gold !py-1.5 !px-4 !text-xs"
            >
              <Phone className="w-3.5 h-3.5 mr-1.5" /> {CONTACT.phone}
            </a>
          </nav>

          <button
            type="button"
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden inline-flex items-center justify-center w-8 h-8 text-tnt-ink hover:text-tnt-gold transition-colors"
            aria-label="Open menu"
          >
            {open ? <X className="w-5 h-5" /> : <MenuIcon className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="md:hidden bg-tnt-bg/98 backdrop-blur-xl border-t border-tnt-border"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`${l.testid}-mobile`}
                className={({ isActive }) =>
                  `font-display text-3xl tracking-wider ${
                    isActive ? "text-tnt-gold" : "text-tnt-ink"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={`tel:${CONTACT.phoneTel}`}
              data-testid="nav-call-cta-mobile"
              className="btn-gold w-full mt-2"
            >
              <Phone className="w-4 h-4 mr-2" /> Call {CONTACT.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
